<template>
  <div class="config">
    <v-row no-gutters class="fill-height">
      <v-col cols="8" class="left-column pa-3">
        <v-progress-circular v-if="item.clientOnly" indeterminate size="128"></v-progress-circular>
        <div v-else class="left-column-content">
          <div class="options">
            <my-option
              v-for="option in item.options"
              :key="option.Id"
              :item="item"
              :option="option"
            ></my-option>
          </div>
          <v-progress-circular v-if="item.loading" indeterminate></v-progress-circular>
        </div>
      </v-col>
      <v-col cols="4" class="right-column pa-3">
        <v-progress-circular v-if="item.clientOnly" indeterminate size="128"></v-progress-circular>
        <div v-else class="right-column-content">
          <h3>{{item.product.name}}</h3>
          <v-img
            :src="item.product.photoSet.individual.smallUrl"
            class="ma-3"
            max-width="100%"
            max-height="100px"
            width="auto"
            height="auto"
            contain
          ></v-img>
          <div class="price">
            <v-progress-circular v-if="item.loading" indeterminate></v-progress-circular>
            <div v-else>{{item.effectivePrice}}</div>
          </div>
          <table class="option-table">
            <tr class="option-row" v-for="option in item.options" :key="option.Id">
              <td class="key">{{option.Name}}</td>
              <td
                class="value"
              >{{!option.SelectedValue ? "Not Selected" : option.SelectedValue.Name}}</td>
            </tr>
          </table>
          <v-btn color="primary" class="ma-3" @click="back()">Back</v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Option from "../components/Option.vue";

export default {
  components: {
    "my-option": Option
  },
  data: function() {
    return {};
  },
  computed: {
    slideshow: function() {
      return this.$store.state.slideshow;
    },
    item: function() {
      return this.clientCart.items.find(
        item => item.id == this.$route.params.itemId
      );
    },
    clientCart: function() {
      return this.$store.getters.clientCart;
    }
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.left-column-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.option-table {
  width: 100%;
  border-collapse: collapse;

  .option-row {
    &:not(:last-child) {
      border-bottom: 1px solid rgb(200, 200, 200);
    }

    &:nth-child(even) {
      background-color: rgb(240, 240, 240);
    }

    td {
      padding: 5px;
    }
    .key {
      font-weight: bold;
    }
    .value {
      text-align: right;
    }
  }
}

.left-column {
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.right-column {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.right-column-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.options {
  width: 100%;

  .option {
    margin: 10px 0px;
  }
}

.config {
  height: 100%;
  width: 100%;
}
</style>

<style lang="scss">
//Pluto.scss
$amp-green: rgb(116, 173, 69);

.options {
  .option {
    margin-bottom: 20px;
    padding: 0px;

    .option-name {
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .option-values {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .option-value {
        margin: 5px;
        border: 1px solid black;

        &:hover {
          border: 1px solid $amp-green;
          cursor: pointer;
        }

        &.disabled {
          pointer-events: none;
          opacity: 0.25;
        }

        &.pre-selected {
          box-shadow: 0px 0px 10px 2px $amp-green;
        }

        &.selected {
          pointer-events: none;

          .option-value-name-container {
            color: white;
            background-color: $amp-green;
          }
        }

        .option-value-image-container {
          height: 100px;
          width: 100px;
          display: flex;
          justify-content: center;
          align-items: center;

          .option-value-image {
            max-height: 100px;
            max-width: 100px;
          }
        }

        .option-value-name-container {
          height: 40px;
          width: 100px;
          display: flex;
          justify-content: center;
          align-items: center;

          .option-value-name {
            padding-left: 3px;
            padding-right: 3px;
            font-size: 14px;
            max-height: 40px;
            max-width: 100px;
            margin: 0px;
            overflow: hidden;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>